module.exports = __webpack_public_path__ + "img/on.76c324ef.jpg";